import React, { useState, useEffect, useRef } from "react";
import "./ComponenteCSS/YouTubeVideo.css";

const YouTubeVideo = ({ videoId, title = "YouTube Video" }) => {
  return (
    <section className="youtube-video-section">
      <h2>Conheça a nossa história</h2>

      <div className="youtube-video-container">
        <div className="youtube-video-wrapper">
          <iframe
            src={`https://www.youtube.com/embed/${videoId}?loading=lazy`}
            title={title}
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowFullScreen
            className="youtube-video-iframe"
            loading="lazy"
          ></iframe>
        </div>
      </div>
    </section>
  );
};

export default YouTubeVideo;
